@if (loading()) {
  <div class="state-wrap" data-testid="lyric-list-loading"><span class="spinner"></span></div>
} @else if (error()) {
  <div class="state-wrap state-error" data-testid="lyric-list-error">
    <p>{{ error() }}</p>
    <button type="button" (click)="retry()" data-testid="lyric-list-retry">{{ 'HOME.LIST.REESSAYER' | translate }}</button>
  </div>
} @else if (items().length) {
  <div class="lyric-cols" data-testid="lyric-list-grid">
    @for (item of items(); track item.id; let i = $index) {
      <ls-lyric-card
        [lyric]="item"
        [href]="cardHref(item)"
        [rank]="mode() === 'popular' ? i + 1 : undefined"
        [rankStyle]="mode() === 'popular' ? 'plain' : 'none'"
        [isNew]="mode() === 'latest' && isNew(item.createdAt)"
        [showArtist]="true"
        [showRecueilOrAlbumDisplay]="true"
        [showViewCount]="mode() === 'popular'"
        [metric]="cardMetric(item)"
        trailingAction="menu"
        [showOpenLyrics]="true"
        [showListenNow]="true"
        [showPlayNext]="true"
        [showAddToPlaylist]="true"
        [showFavorite]="true"
        [showShare]="true"
        data-testid="lyric-row"
        [attr.data-slug]="item.slug"
      />
    }
  </div>

  @if (paginate()) {
    <div class="pagination" data-testid="pagination">
      <button
        type="button"
        [disabled]="!hasPrev()"
        (click)="prevPage()"
        [attr.aria-label]="'HOME.LIST.PAGE_PRECEDENTE' | translate"
        data-testid="pagination-prev"
      >
        <i class="ls-chevron-left"></i> {{ 'HOME.LIST.PRECEDENT' | translate }}
      </button>
      <span class="page-indicator" data-testid="pagination-indicator"
        >Page {{ page() }} / {{ totalPages() }}</span
      >
      <button
        type="button"
        [disabled]="!hasNext()"
        (click)="nextPage()"
        [attr.aria-label]="'HOME.LIST.PAGE_SUIVANTE' | translate"
        data-testid="pagination-next"
      >
        {{ 'HOME.LIST.SUIVANT' | translate }} <i class="ls-chevron-right"></i>
      </button>
    </div>
  }
}
